module.exports = __webpack_public_path__ + "img/vegas-25.71e05883.png";